import { useNavigate } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosAgendamientoEnumChoice, ROUTER_PATHS } from '@/shared';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { hasPermission } from '@/shared/utils';
import { useGetAgendaCorporativas } from '@/shared/actions/erp/agendamiento_corporativo';
import { useTableColumnsAgendaCorporativa } from '@/shared/hooks/useTableColumnsAgendaCorporativa';
import { IAgendaCorporativo } from '@/shared/interfaces/erp/agenda_corporativo';
import { useState } from 'react';

type AgendaAprobadosCorporativoPageProps = {
  stateAgendamiento?: EstadosAgendamientoEnumChoice;
};

const AgendaAprobadosCorporativoPage: React.FC<AgendaAprobadosCorporativoPageProps> = ({
  stateAgendamiento = EstadosAgendamientoEnumChoice.FINALIZADO,
}) => {
  const navigate = useNavigate();
  useCheckPermissions(PermissionsEnum.api_view_agendacorporativa)

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  //
  const [rowSelection, setRowSelection]=useState({})
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter()

  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: agendamientosPagingRes,
    isLoading,
    isRefetching,
  } = useGetAgendaCorporativas({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_agenda: stateAgendamiento,
    },
  });

  ///* columns
  const { columnsAgendaCoporativo } =
    useTableColumnsAgendaCorporativa(stateAgendamiento);


  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      //onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<IAgendaCorporativo>
        columns={
          columnsAgendaCoporativo
        }
        data={agendamientosPagingRes?.data.data ?? []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={agendamientosPagingRes?.data?.count}
        // // // actions ========
        enableColumnActions={true}
        enableEditing={true}
        //
        enableSelectAll
        enableRowSelection
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        pinLeftColumnIndexes={[0,1,2]}
        // crud
        canEdit={hasPermission(PermissionsEnum.api_change_agendamiento)}
        onEdit={(row) => {
          navigate(
            `${ROUTER_PATHS.noc.reasignarAgendaCorpNav}/${row.id_agenda_corporativa}`
          );
        }}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default AgendaAprobadosCorporativoPage;
